import React from 'react';
import { Radio } from 'antd';

interface RadioFormProps {
  title?: string;
  data: { id: number; score: number | null; question: string }[];
  options?: string[];
  isDisabled?: boolean;
  onChange: (questionIndex: number, value: number) => void;
}

const RadioForm: React.FC<RadioFormProps> = ({
  options = [
    'Strongly Disagree',
    'Disagree',
    'Neutral',
    'Agree',
    'Strongly Agree',
  ],
  onChange,
  isDisabled = false,
  data,
}) => {
  return (
    <div className="space-y-6">
      <div
        className={`grid ${options.length === 3 ? 'grid-cols-[1fr,repeat(3,0.1fr)]' : 'grid-cols-[1fr,repeat(5,0.1fr)]'} gap-x-8 gap-y-6`}
      >
        {/* Header Row */}
        <div></div>
        {options.map((header) => (
          <div key={header} className="text-center font-semibold pb-4">
            {header}
          </div>
        ))}

        {/* Questions and Radio Buttons */}
        {data.map((item, index) => (
          <React.Fragment key={index}>
            <div className="pr-4 py-2">{item.question}</div>
            <Radio.Group
              disabled={isDisabled}
              className="contents"
              onChange={(e) => onChange(item.id, e.target.value)}
              value={item.score}
            >
              {options.map((option, xPosition) => (
                <div key={option} className="flex justify-center items-center">
                  <Radio disabled={isDisabled} value={xPosition} />
                </div>
              ))}
            </Radio.Group>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default RadioForm;
